import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Output() event = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  handleEvent(event: any) {
    this.event.emit(event);
  }

}
